const NavMain = props => {
    return (
        <nav className="navbar navbar-light bg-white fixed-top d-flex align-items-center">
            <a className="navbar-brand mr-auto" href="http://www.fao.org/home/es/" target="_blank" rel="noreferrer">
                <img src={props.logo} alt="FAO - Home" />
            </a>

            <div className="up-buttons">
                <button type="button" className="btn btn-dark btn-scroll-top" data-toggle="modal" data-target="#copyrightModal">{props.copyright}</button>
                <button type="button" className="btn btn-dark btn-scroll-top" data-toggle="modal" data-target="#ack">{props.acknowledgements}</button>
                <button onClick={onClickScrollTop} type="button" id="scrollTop" className="btn btn-dark btn-scroll-top">{props.scroll}</button>
            </div>
                <div className="dropdown dropleft">
                <button className="btn btn-secondary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    ES
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a className="dropdown-item" href="https://www.fao.org/3/cc7088fr/online/cc7088fr.html">FR</a>
                    <a className="dropdown-item" href="https://www.fao.org/3/cc7088es/online/cc7088es.html">ES</a>
                    <a className="dropdown-item" href="https://www.fao.org/3/cc7088ru/online/cc7088ru.html">RU</a>
                    <a className="dropdown-item" href="https://www.fao.org/3/cc7088ar/online/cc7088ar.html">AR</a>
                    <a className="dropdown-item" href="https://www.fao.org/3/cc708zh/online/cc7088zh.html">ZH</a>
                    <a className="dropdown-item" href="https://www.fao.org/3/cc7088en/online/cc7088en.html">EN</a>
                </div>
            </div>
        </nav>
    ) 
}

const onClickScrollTop = () => {
    document.body.scrollTo({
        top: 0,
        behavior: 'smooth',
    })
}

export default NavMain;
